export default __webpack_public_path__ + "static/Vip-1b9c583e964a6d312dcdf9e20baed280.jpg";